export default "__VITE_ASSET__CmfnioBN__"